//
// GTLSortState.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DiscreteSort";

var GTLSortState = createModule("gtl::GTLSortState", [], EventDispatcher, [
    {
        SORT_STATE_CHANGED: 30032,
    },
    ,
    ,
    ,
    {
        addDiscreteSort: [0,1],
        removeAllDiscreteSorts: [0],
        getDiscreteSorts: [[1]],
        removeDiscreteSort: [0,1],
        isEmpty: [2],
        _findDiscreteSort_on: [1,1,4],
        _findDiscreteSort_o: [1,1],
    },
    {
        computeOrderedCustomSortValues: [[7],7,7,1],
    },
    ["findDiscreteSort"],
]);
export default GTLSortState;
